import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoRightClick]',
})

export class NoRightClickDirective {
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/directives/no-rigth-click/no-rigth-click.directive.ts